import React from 'react';
import { message } from 'antd'

import RandomizeForm from '../../components/Randomize/RandomizeAdmin'
import { Results } from '../../components/Results/ResultsAdmin'

import { getSitesRequest, randomizeRequest } from '../../api/requests';
import isAuthenticated from '../../utils/isAuthenticated';


class RandomizeAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: '',
      studyID: '',
      dose: '',
      consentType: '',
      randomized: false,
      loading: false,
      sites: []
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this)
  }

  async componentDidMount() {
    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data.filter(item => item.site_type === 'randomization') });
    } catch (e) { console.log(e); }
  }

  async handleSubmit(values) {

    this.setState({
      loading: true
    });

    try {
      const { data } = await randomizeRequest(values);

      this.setState({
        date: data.randomization_date,
        studyID: data.study_id,
        bottle_no: data.bottle_no,
        dose: data.dose,
        randomized: true,
        loading: false
      });

      this.props.getSubject(this.props.subjectID, true);
    } catch (e) {
      if (e.response) {
        const errors = e.response.data.error;
        if (errors) {
          message.config({ style: { color: '#424242' } });
          message.error(errors, 5)
        }
      }

      this.setState({
        date: '',
        studyID: '',
        dose: '',
        randomized: false,
        loading: false
      });
    }
  }

  handleReset() {
    this.setState({
      date: '',
      studyID: '',
      dose: '',
      randomized: false,
      loading: false
    });

    this.props.onSubmit(this.props.subjectID, true);
  }

  render() {
    const { loading, randomized, sites } = this.state;
    const { isEditableRandomize, drug_location, dispensingSites, subject } = this.props;

    return (
        <div>
          <div style={{ display: randomized ? 'block' : 'none' }}><Results {...this.state} onBackClick={this.handleReset} /></div>

          <div style={{ display: randomized ? 'none' : 'block' }}>
            <RandomizeForm isEditableRandomize={isEditableRandomize} subject={subject} dispensingSites={dispensingSites} drug_location={drug_location} sites={sites} site={this.props.site} loading={loading} handleSubmit={this.handleSubmit} profile={this.props.profileCopy || this.props.profile} profileCode={this.props.profileCode} randomizationConducted={this.props.randomizationConducted} />
          </div>
        </div>
    );
  }
}

export default isAuthenticated(RandomizeAdmin);



// WEBPACK FOOTER //
// ./src/containers/RandomizeAdmin/RandomizeAdmin.js